import axios from "axios";

let baseURL = "https://" + location.host + "/v1";

const hostname = process.env.VUE_APP_HOSTNAME;

if (hostname) baseURL = hostname + "/v1";

const client = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Content-Language": `pt-BR`,
  },
});

if (localStorage.getItem("token")) {
  client.interceptors.request.use(
    async (config) => {
      config.headers["Authorization"] = localStorage.getItem("token");
      return config;
    },
    (error) => Promise.reject(error)
  );
}

client.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    const accessToken = localStorage.getItem("token");
    // eslint-disable-next-line no-param-reassign
    if (accessToken){
    try{
      var base64Url = accessToken.split('.')[1];
			var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			var jsonPayload = JSON.parse(decodeURIComponent(window.atob(base64).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join('')));
			const date = new Date(jsonPayload.exp * 1000)
			if(date < new Date()){
				store.dispatch("users/doLogout");
				window.location.href = "/login"
			}
          }
          catch(error){
            localStorage.removeItem("token");
            window.location.href = "/login"
          }
        }
    if (accessToken) config.headers.Authorization = `${accessToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

 client.interceptors.response.use(
 	(response) => response,
 	(error) => {
 	  switch (error.response?.status) {
// 		case 403 :
// 		  router.push("/login");
// 		  break;
 		case 401:
            //router.push("/login");
            window.location.href = "/login"
            break;
// 		case 409:
// 			console.log("409")
// 			break;
// 		case 500:
// 			console.log("500")
// 			break;
 		default :
            throw error;
 			break;
 	  }
// 	  return Promise.reject(error);
 	}
   );

export default client;
